module.exports = __webpack_public_path__ + "img/thumb_33.bf232319.jpg";